<template>
    <rkm-area
        no-margin-top
        title="Intervenções e/ou procedimentos clínicos"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.procedimentos"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="6">
                                <Item
                                    :get-value="() => `${formatProcedimento(item.procedimento.codigo)} - ${item.procedimento.nome}`"
                                    label="Procedimento"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <Item
                                    :get-value="() => item.quantidade"
                                    label="Quantidade"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    :get-value="() => item.cid ? `${formatCid(item.cid.codigo)} - ${item.cid.nome}` : null"
                                    label="CID"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="item.observacao">
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.observacao"
                                    label="Observação"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>
